<h1>
    <span>Patient Journey Details</span>
    <button type="button" (click)="CloseModal()" class="btn btn-default float-right">Close</button>
</h1>
<hr />
<div class="form-group">
    <div class="row" *ngIf="!dataLoaded"><i class="fa fa-spin fa-spinner"></i></div>
    <div class="row" *ngIf="dataLoaded">
        <div class="col-sm-6">
            <label class="label"> Patient Name : </label>&nbsp;
            <span>{{patient_name}}</span>
        </div>
        <div class="col-sm-6">
            <label class="label"> Phone No : </label>&nbsp;
            <span>{{phone}}</span>
        </div><br><br>
        <div class="col-sm-6">
            <label class="label"> Patient Journey Cancel Remark : </label>&nbsp;
            <span>{{cancel_ipd_remarks}}</span>
        </div>
    </div>
</div>